import React from "react";
import PropTypes from "prop-types";

import Modal from "core/Modal";
import Button from "core/Button";

import { ModalChildrenContainer, DeletePhotosButton } from "./styles";
import { useSelect } from "frontend/components/creator-tools/PhotoUploadPage/PhotoUpload/hooks/useSelect";

import { useWithdrawPhotoUpload } from "frontend/components/creator-tools/PhotoUploadPage/PhotoUploadCore/hooks";

const DeletePhotosModal = ({
    onClose,
    numPhotosToDelete,
    isDeletePhotoModalOpen
}) => {
    const isQuantityMultiple = numPhotosToDelete > 1;

    const headingSingle = "Are you sure you want to delete this photo?";
    const headingMultiple = `Are you sure you want to delete ${numPhotosToDelete} photos?`;

    const heading = isQuantityMultiple ? headingMultiple : headingSingle;

    const buttonText = `Yes, delete photo${isQuantityMultiple ? "s" : ""}`;

    const { isChecked, clearAllChecked } = useSelect();

    // WITHDRAW PHOTO MUTATION
    const { withdrawPhotos } = useWithdrawPhotoUpload();

    const handleDeleteSelected = () => {
        let currentlyCheckedPhotoIds = [];
        Object.entries(isChecked).forEach(([key, value]) => {
            if (value) currentlyCheckedPhotoIds.push(key);
        });

        clearAllChecked();
        onClose();
        withdrawPhotos({
            variables: { photoUploadIds: currentlyCheckedPhotoIds }
        });
    };

    const footerChildren = (
        <>
            <DeletePhotosButton onClick={handleDeleteSelected}>
                {buttonText}
            </DeletePhotosButton>
            <Button onClick={onClose} styleType={"outline"}>
                Cancel
            </Button>
        </>
    );

    return (
        <Modal
            open={isDeletePhotoModalOpen}
            onClose={onClose}
            handleClose={onClose}
            heading={heading}
        >
            <ModalChildrenContainer>{footerChildren}</ModalChildrenContainer>
        </Modal>
    );
};

DeletePhotosModal.propTypes = {
    numPhotosToDelete: PropTypes.number.isRequired,
    onClose: PropTypes.func.isRequired,
    isDeletePhotoModalOpen: PropTypes.bool.isRequired
};

export default DeletePhotosModal;
